(function () {
  'use strict';

  angular
    .module('trainingDiscrepancy')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('trainingDiscrepancy', {
        url: '/training-discrepancy',
        views : {
			'trainingDiscrepancyView' : {
				templateUrl : 'training-discrepancy/views/training-discrepancy.tpl.html',
				controller : 'TrainingDiscrepancyCtrl',
				controllerAs : 'trainingDiscrepancy'
			}
		},
      });
  }
}());
